export default __webpack_public_path__ + "static/media/lava-ui-laptop-side.fe723816.webp";